import { ForwardedRef, forwardRef, useImperativeHandle, useState } from 'react'
import { LIMITS } from '@weblite/permission'
// Material
import { Box } from '@mui/material'
import styled from '@emotion/styled'
// Common
import { Label } from '$common/label'
import { TextInput } from '$common/input'
// Localization
import { t } from '$i18n'
// Helpers
import { getClientUser } from '$logic/client-user'
// Components
import { EditAccountProfileBox } from './edit-account-profile-box'

const { userConstraints } = LIMITS

const StyledBox = styled(Box)`
  height: fit-content;
  position: relative;
`

export interface EditAccountCommonBoxApiType {
  getFirstname: () => string
  getLastname: () => string
}

export const EditAccountCommonInfo = forwardRef(
  (
    {
      forwardedRef,
      firstNameIsEmpty,
    }: {
      forwardedRef: ForwardedRef<EditAccountCommonBoxApiType>
      firstNameIsEmpty: boolean
    },
    imageRef,
  ) => {
    const user = getClientUser()
    const [firstname, setFirstname] = useState<string>(user.firstname)
    const [lastname, setLastname] = useState<string>(user.lastname)

    useImperativeHandle(
      forwardedRef,
      () => ({
        getFirstname: () => firstname,
        getLastname: () => lastname,
      }),
      [firstname, lastname],
    )

    return (
      <StyledBox>
        <EditAccountProfileBox ref={imageRef} />
        <Label title={t('user.name')} required />
        <TextInput
          placeholder={t('user.enterName')}
          value={firstname}
          onChange={setFirstname}
          hasError={firstNameIsEmpty}
          errorMessage={t('signup.emptyName')}
          maxLength={userConstraints.firstname.maxLength}
        // disabled={true}
        />

        <Label title={t('user.lastName')} />
        <TextInput
          placeholder={t('user.enterLastName')}
          value={lastname}
          onChange={setLastname}
          maxLength={userConstraints.lastname.maxLength}
        // disabled={true}
        />
      </StyledBox>
    )
  },
)
